import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledCardComponent } from "./card-component.scss";
import colors from "/styles/colors";
class CardComponent extends PureComponent {
    render() {
        const { height, width, children, background } = this.props;
        const style = {
            height: height,
            width: width,
            backgroundColor: colors[background]
        };
        return /*#__PURE__*/ _jsx(StyledCardComponent, {
            className: "card-component",
            style: style,
            children: children
        });
    }
    constructor(props){
        super(props);
    }
}
export { CardComponent as default };
